"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateYears = calculateYears;
exports.getDateForApiDateStr = getDateForApiDateStr;
exports.displayNextAvailableDay = displayNextAvailableDay;
exports.getFormattedWhenObject = getFormattedWhenObject;
exports.timeOfDay = timeOfDay;
exports.formatTimeStamp = formatTimeStamp;
exports.toTwoDigits = toTwoDigits;
exports.getBitsTimeSinceMidnight = getBitsTimeSinceMidnight;
exports.getOptionsForSelectedFulfillMethod = getOptionsForSelectedFulfillMethod;
exports.calculateTimes = calculateTimes;
exports.parseExpirationDate = parseExpirationDate;
exports.months = exports.MINUTES_PER_HOUR = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.reduce.js");

var _lodash = require("lodash");

var _dateFns = _interopRequireDefault(require("date-fns"));

require("core-js/es/array");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const {
  addMinutes,
  format,
  isToday,
  isTomorrow
} = _dateFns.default;
const ORDER_WHEN_OPTIONS = {
  later: {
    label: 'Order Ahead',
    // Indicates the order is for later but user needs to pick date & time
    value: undefined
  },
  now: {
    label: 'ASAP',
    // The CN API represents orders for now by passing `null` for `when`
    value: null
  }
};
const MINUTES_PER_HOUR = 60;
exports.MINUTES_PER_HOUR = MINUTES_PER_HOUR;
const months = [{
  id: 1,
  label: '01 - January'
}, {
  id: 2,
  label: '02 - February'
}, {
  id: 3,
  label: '03 - March'
}, {
  id: 4,
  label: '04 - April'
}, {
  id: 5,
  label: '05 - May'
}, {
  id: 6,
  label: '06 - June'
}, {
  id: 7,
  label: '07 - July'
}, {
  id: 8,
  label: '08 - August'
}, {
  id: 9,
  label: '09 - September'
}, {
  id: 10,
  label: '10 - October'
}, {
  id: 11,
  label: '11 - November'
}, {
  id: 12,
  label: '12 - December'
}];
exports.months = months;

function calculateYears() {
  let year = new Date().getFullYear() - 1;
  return (0, _lodash.times)(12, () => year += 1); // eslint-disable-line
}
/**
 * Generates a JavaScript Date object from a CN API Date/Time string. If no
 * time is provided, the returned date will be for the start of the day.
 * @param dateStr {string} Can be in the 'YYYYMMDD', 'YYYY-MM-DD' or 'YYYYMMDDHHMM' format.
 * @returns {date|null} A JS Date object based on the received string or null for invalid input.
 */


function getDateForApiDateStr(dateStr) {
  // Catch all RegEx for API date strings w/ capture groups
  const apiDateStrRegex = /(\d{4})-?(\d{2})-?(\d{2})(\d{2})?(\d{2})?/;
  const result = apiDateStrRegex.exec(dateStr);
  let dateParts;

  if (result && result.length >= 4) {
    // Pull out date parts by executing regex, extracting capture groups and filtering out undefined values
    dateParts = result.slice(1).filter(datePart => datePart); // JS Date months are a zero based index

    dateParts[1] -= 1;
  }

  return dateParts ? new Date(...dateParts) : null;
}
/**
 * Returns a string that describes the next available order day
 * @param date {date} Takes in JS Date
 * @returns {string} will return 'Today', 'Tomorrow', or a day of the week
 */


function displayNextAvailableDay(date) {
  if (isToday(date)) return 'today';
  if (isTomorrow(date)) return 'tomorrow';
  return format(date, 'dddd');
}
/**
 * Returns a string that describes the next available order day
 * @param dateStr {string} Takes in string format of date that API returns - YYYYMMDDHHmm
 * @param precision {number} Precision of space between order ahead times
 * @returns {object} will return object of formatted date, time start and time end
 */


function getFormattedWhenObject(dateStr, precision) {
  const formattedWhen = getDateForApiDateStr(dateStr);
  const fulfillmentDate = format(formattedWhen, 'ddd, MMM D'); // Mon, Jan 1

  const fulfillmentTimeStart = format(formattedWhen, 'h:mm A'); // 7:35pm

  const fulfillmentTimeEnd = format(addMinutes(formattedWhen, precision), 'h:mm A');
  return {
    fulfillmentDate,
    fulfillmentTimeStart,
    fulfillmentTimeEnd
  };
} // morning = 1-12, afternoon = 12-18, evening = 18+


function timeOfDay() {
  const hour = new Date().getHours();

  if (hour > 18) {
    return 'Evening';
  } else if (hour >= 12) {
    return 'Afternoon';
  } else {
    return 'Morning';
  }
}
/**
 * Formats the time slot for an order to be shown in the UI
 * @param dateSinceMidnight {object} a custom type containing formatted time
 * @returns {object} returns an object formatted:
 * {label: '11:00 am', value: 1100}
 */


function formatTimeStamp(_ref) {
  let {
    formatted
  } = _ref;
  return {
    label: "".concat(formatted['h:mm A']),
    value: formatted.HHmm
  };
}

function toTwoDigits(val) {
  // Ensure that single digit numbers are prepended by a `0`
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
  return val.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  });
}
/**
 * Returns a custom Type that contains information about time from an arbitrary midnight
 * Contains both raw time as hours and minute ints, as well as a lookup of formatted times
 * Because our API expresses time as bits, it's important that we use a generic concept of "midight"
 * To avoid daylight savings issues, which can show up with native Date objects in browsers
 * @param {object} an object containing the keys
 * firstAvailableBit - a number representing the first time slot open on a menu
 * precision - a number representing the frequency of the next time slot (in minutes)
 */


function getBitsTimeSinceMidnight(_ref2) {
  let {
    firstAvailableBit,
    precision
  } = _ref2;
  const offSetInMilliseconds = firstAvailableBit * precision * 60000;
  const midnight = new Date('December 1, 2001 00:00:00'); // Add offset in MS to generic midnight Date

  const dateSinceMidnight = new Date(midnight.getTime() + offSetInMilliseconds);
  return {
    hours: toTwoDigits(dateSinceMidnight.getHours()),
    minutes: toTwoDigits(dateSinceMidnight.getMinutes()),
    formatted: {
      HHmm: format(dateSinceMidnight, 'HHmm'),
      'h:mm A': format(dateSinceMidnight, 'h:mm A')
    }
  };
}
/**
 * Formats the time slots for an order
 * @param orderAhead {object} an API OrderAhead object
 * @param selectedDate {string} A formatted API timestamp
 * @param fulfillMethod {string} A string matching pickup/delivery/curbside
 * @returns {array} returns a list of time slots formatted for the UI
 */


function getOptionsForSelectedFulfillMethod(_ref3) {
  let {
    orderAhead,
    selectedDate,
    fulfillMethod
  } = _ref3;

  if (orderAhead && orderAhead.days) {
    const selectedDay = orderAhead.days.find(day => {
      return day.date === format(selectedDate, 'YYYY-MM-DD');
    });

    if (selectedDay) {
      return selectedDay[fulfillMethod].reduce((acc, slot, index) => {
        if (slot) {
          const timeSinceMidnight = getBitsTimeSinceMidnight({
            firstAvailableBit: index,
            precision: orderAhead.precision
          });
          return acc.concat(formatTimeStamp(timeSinceMidnight));
        }

        return acc;
      }, []);
    }
  }

  return [];
}
/**
 * Returns a list of formatted Order Time Slots
 * @param dateSTr {string} An API formatted date
 * @param isSelectedFulfillmentAvailableNow {Bool} a bool describing if
 * a given fulfillment option is currently available
 * @param orderAhead {object} an API OrderAhead object
 * @param fulfillMethod {string} A string matching pickup/delivery/curbside
 * @returns {array} returns a list of time slots formatted for the UI
 */


function calculateTimes(_ref4) {
  let {
    dateStr,
    isSelectedFulfillmentAvailableNow,
    orderAhead,
    fulfillMethod
  } = _ref4;
  const selectedDate = getDateForApiDateStr(dateStr);
  const formattedOptions = getOptionsForSelectedFulfillMethod({
    orderAhead,
    selectedDate,
    fulfillMethod
  });

  if (isSelectedFulfillmentAvailableNow && isToday(selectedDate)) {
    return [ORDER_WHEN_OPTIONS.now, ...formattedOptions];
  }

  return formattedOptions;
}

function parseExpirationDate(expirationDate) {
  const expiresAtParsed = getDateForApiDateStr(expirationDate);
  const date = new Date(expiresAtParsed);
  return new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  }).format(date);
}